// "Çıktıyı malzemelerden hesapla": aynı birim ailesindeki malzeme miktarlarını
// çıktı birimine çevirip toplar. Fire eklenmez: fire ürüne girmeyen kayıptır;
// ürüne giren miktar reçete satırındaki net miktardır.

type UnitFamily = 'mass' | 'volume';

interface UnitInfo {
  family: UnitFamily;
  /** Ailenin küçük birimine (gram / mililitre) çarpan. */
  factor: number;
}

const UNITS: Record<string, UnitInfo> = {
  mg: { family: 'mass', factor: 0.001 },
  miligram: { family: 'mass', factor: 0.001 },
  g: { family: 'mass', factor: 1 },
  gr: { family: 'mass', factor: 1 },
  gram: { family: 'mass', factor: 1 },
  kg: { family: 'mass', factor: 1000 },
  kilo: { family: 'mass', factor: 1000 },
  kilogram: { family: 'mass', factor: 1000 },
  ton: { family: 'mass', factor: 1_000_000 },
  ml: { family: 'volume', factor: 1 },
  mililitre: { family: 'volume', factor: 1 },
  cl: { family: 'volume', factor: 10 },
  l: { family: 'volume', factor: 1000 },
  lt: { family: 'volume', factor: 1000 },
  litre: { family: 'volume', factor: 1000 },
  liter: { family: 'volume', factor: 1000 },
};

export function unitInfo(unit?: string | null): UnitInfo | null {
  const key = (unit ?? '').trim().toLocaleLowerCase('tr-TR').replace(/\.$/, '');
  return UNITS[key] ?? null;
}

export interface OutputCalcLine {
  name: string;
  quantity: number;
  unit: string;
}

export interface OutputCalcResult {
  /** Çıktı biriminde toplam; çıktı birimi tanınmıyorsa ya da hiçbir satır çevrilemiyorsa null. */
  total: number | null;
  /** Çıktı birimi ağırlık/hacim değil. */
  outputUnitUnknown: boolean;
  /** Çevrilemeyen (farklı aile ya da adet gibi) satırların adları. */
  skipped: string[];
}

export function sumIngredientsToOutput(lines: OutputCalcLine[], outputUnit: string): OutputCalcResult {
  const target = unitInfo(outputUnit);
  if (!target) return { total: null, outputUnitUnknown: true, skipped: lines.map((line) => line.name) };

  let small = 0;
  let used = 0;
  const skipped: string[] = [];
  lines.forEach((line) => {
    const info = unitInfo(line.unit);
    if (!info || info.family !== target.family || !Number.isFinite(line.quantity)) {
      skipped.push(line.name);
      return;
    }
    small += line.quantity * info.factor;
    used += 1;
  });

  if (used === 0) return { total: null, outputUnitUnknown: false, skipped };
  const total = Math.round((small / target.factor) * 1000) / 1000;
  return { total, outputUnitUnknown: false, skipped };
}
